module.exports = __webpack_public_path__ + "img/20190918172018360截图20190918161509272.642218a9.jpg";